<div class="tooltip-wrapper">
    <div class="issue-list">
        @for (errorCode of errorCodes(); track errorCode) {
            <div class="issue-item">
                <i class="fa fa-circle-xmark error"></i>
                <span>{{ ERROR_TRANSLATIONS[errorCode] | translate }}</span>
            </div>
        }
        @for (warningCode of warningCodes(); track warningCode) {
            <div class="issue-item">
                <i class="fa fa-warning warning"></i>
                <span>{{ WARNING_TRANSLATIONS[warningCode] | translate }}</span>
            </div>
        }
    </div>
</div>
